/**
 * 骑手状态变更弹框
 */
import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from './LockDown.module.scss';
import { XTextArea } from '@/components/xqxc_ui';
import { message } from 'antd';
import http from '@/assets/api/http';

class LockDown extends React.Component {

    state = {
        confirmLoading: false,
        unblockRemark: '', // 封禁原因
    }

    _handleOk = () => {
        const { data } = this.props;
        const { unblockRemark } = this.state;
        const blockAccountId = data.id;
        const blockType = data.blockType;

        if (!this._isHaveValue(unblockRemark) || unblockRemark.toString().length < 5) {
            message.warning('请输入解封原因，最少输入5个字符');
        } else {
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.BlockLogMisService.unblock', { blockAccountId, unblockRemark, blockType }, 'POST').then(() => {
                message.success('解封成功');
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
            });
        }
    }

    // 检查是否有输入
    _isHaveValue = (val) => {
        if (val === '' || val === null || val === undefined) {
            return false;
        } else {
            return true;
        }
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading, unblockRemark } = this.state;
        const { data } = this.props;

        return (
            <Modal
                width={600}
                centered
                title='解封'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <div className={styles.tel}>手机号：{data.tel}</div>
                    <div className={styles.type}>账户类型：{data.type}</div>
                    <XTextArea
                        isRequired={true}
                        style={{ marginTop: '10px' }}
                        inputStyle={{ width: '360px', resize: 'none' }}
                        label='解封原因'
                        placeholder='请输入至少五个字符'
                        value={unblockRemark}
                        bindThis={this}
                        bindName='unblockRemark'
                        maxLength='200'
                        showLength={true}
                    />
                </div>
            </Modal>
        );
    }
}

LockDown.propTypes = {
    data: PropTypes.object, // 弹窗传递参数
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default LockDown;